import Modal from '../classes/ModalClass';

const selectors = {
  el: '.js-modal:not(.is-initialized)',
};

const init = () => {
  const els = document.querySelectorAll(selectors.el);
  const mq = window.matchMedia('(max-width: 767px)');

  els.forEach(el => {
    const isMobile = el.dataset.mobile;

    if (isMobile && !mq.matches) return;
    el.modal = new Modal(el);
  });

  window.addEventListener('resize', () => {
    els.forEach(el => {
      const isMobile = el.dataset.mobile;

      if (!isMobile) return;
      if (el.modal && !mq.matches) {
        el.modal.destroy();
        el.modal = null;
      } else if (!el.modal && mq.matches) {
        el.modal = new Modal(el);
      }
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
